import React, { useState } from "react";
import { Button, Dropdown, message } from "antd";
import {
  DownloadOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import type { AgentContainerExportFormat } from "../../utils/agentContainerExport";

interface AgentContainerExportDropdownProps {
  disabled?: boolean;
  onExport: (format: AgentContainerExportFormat) => Promise<void>;
}

export const AgentContainerExportDropdown: React.FC<
  AgentContainerExportDropdownProps
> = ({ disabled = false, onExport }) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async (format: AgentContainerExportFormat) => {
    try {
      setExporting(true);
      await onExport(format);
    } catch (error) {
      console.error("Export failed:", error);
      message.error("Failed to download file");
    } finally {
      setExporting(false);
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "pdf",
      label: "Download PDF",
      icon: <FilePdfOutlined />,
      onClick: () => {
        void handleExport("pdf");
      },
    },
    {
      key: "excel",
      label: "Download Excel",
      icon: <FileExcelOutlined />,
      onClick: () => {
        void handleExport("excel");
      },
    },
    {
      key: "csv",
      label: "Download CSV",
      icon: <FileTextOutlined />,
      onClick: () => {
        void handleExport("csv");
      },
    },
  ];

  return (
    <Dropdown menu={{ items }} disabled={disabled || exporting}>
      <Button
        icon={<DownloadOutlined />}
        size="small"
        loading={exporting}
        disabled={disabled}
      >
        Download <DownOutlined />
      </Button>
    </Dropdown>
  );
};
